export default __webpack_public_path__ + "static/media/White-Pattern-Banner-Background.17691d59.webp";